export default __webpack_public_path__ + "static/media/Tether-icon.b2fa144a.png";